export { CatchBoundary, default, handle, meta } from "/Users/julian/work/personal/wwsu-2022/app/routes/$festivalSlug/events/$eventSlug.tsx";